import React from 'react';
import RangeGauge from 'ui/RangeGauge';
import { invalidAssessmentError } from './helpers.js';

const ConfidenceModule = ({
  assessmentData,
  assessmentError,
  componentIndex,
}) => {
  const between = (x, min, max) => {
    return x >= min && x <= max;
  };

  const invalidConfidenceScore =
    !assessmentData?.formattedAssistedGrade?.confidence &&
    assessmentData?.formattedAssistedGrade?.confidence !== 0;

  const confidenceValue = assessmentData?.formattedAssistedGrade?.confidence;
  const aiMLSupport = assessmentData.aiMultiLanguageSupport;

  const calculatedConfidenceValue = () => {
    if (aiMLSupport) {
      return Math.round(confidenceValue);
    }
    return (Math.round(confidenceValue * 100) / 100) * 10;
  };

  const confidenceQualitativeValue = () => {
    const confidenceScore = calculatedConfidenceValue();
    if (aiMLSupport) {
      if (between(confidenceScore, 3, 5)) {
        return 'High Confidence';
      }
      if (confidenceScore === 2) {
        return 'Moderate Confidence';
      }
      if (confidenceScore === 1) {
        return 'Low Confidence';
      }
    }
    if (between(confidenceScore, 8.1, 10)) {
      return 'High Confidence';
    }
    if (between(confidenceScore, 2.1, 8)) {
      return 'Moderate Confidence';
    }
    if (
      between(confidenceScore, 0, 2) ||
      confidenceScore < 0 //negative values are not expected, this check is put in place only in case AI/ML team's fix gets rolled back
    ) {
      return 'Low Confidence';
    }
    return null;
  };

  const confidenceIconType = () => {
    const confidenceScore = calculatedConfidenceValue();
    if (assessmentData.aiMultiLanguageSupport) {
      if (between(confidenceScore, 3, 5)) {
        return 'high';
      }
      if (confidenceScore === 2) {
        return 'moderate';
      }
      if (confidenceScore === 1) {
        return 'low';
      }
    }
    if (between(confidenceScore, 8.1, 10)) {
      return 'high';
    }
    if (between(confidenceScore, 2.1, 8)) {
      return 'moderate';
    }
    if (
      between(confidenceScore, 0, 2) ||
      confidenceScore < 0 //negative values are not expected, this check is put in place only in case AI/ML team's fix gets rolled back
    ) {
      return 'low';
    }
    return null;
  };

  const getThresholdData = () => {
    if (aiMLSupport) {
      return [
        [0.5, 1.4],
        [1.5, 2.4],
        [3, 5],
      ];
    }
    return [
      [0, 2],
      [2.1, 8],
      [8.1, 10],
    ];
  };

  return (
    <>
      <RangeGauge
        ranges={[
          {
            type: 'danger',
            width: 33,
            startingThreshold: getThresholdData()[0][0],
            endingThreshold: getThresholdData()[0][1],
          },
          {
            type: 'caution',
            width: 33,
            startingThreshold: getThresholdData()[1][0],
            endingThreshold: getThresholdData()[1][1],
          },
          {
            type: 'safe',
            width: 33,
            startingThreshold: getThresholdData()[2][0],
            endingThreshold: getThresholdData()[2][1],
          },
        ]}
        value={calculatedConfidenceValue()}
        overallEndThreshold={100}
        componentIndex={componentIndex}
        qualitativeValue={confidenceQualitativeValue()}
        quantitativeValue={
          assessmentData.assistedGradingStatus === 'complete' &&
          !invalidConfidenceScore &&
          !assessmentError &&
          confidenceIconType()
        }
        tooltipText={t(
          'automated_analysis.confidence_score.tooltip_grading_station',
        )}
        featureName={t('automated_analysis.confidence_score.usage')}
        rangesCanBeRendered={
          assessmentData.assistedGradingStatus === 'complete' ||
          !invalidConfidenceScore
        }
        status={assessmentData.assistedGradingStatus}
        hasIcon
        betaFeature
        error={assessmentError}
        invalidValue={invalidConfidenceScore}
        invalidAssessmentError={invalidAssessmentError(assessmentData)}
      />
    </>
  );
};

export default ConfidenceModule;
